import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL, SITE_OG_IMAGE } from '../config/site';

const upsertMeta = (name, content, isProperty = false) => {
  if (content === undefined || content === null || content === '') return;
  const attribute = isProperty ? 'property' : 'name';
  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertCanonical = (href) => {
  if (!href) return;
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const upsertHreflang = (hreflang, href) => {
  if (!href) return;
  let element = document.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'alternate');
    element.setAttribute('hreflang', hreflang);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  noindex = false,
}) => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const pageUrl = `${SITE_URL}${location.pathname}`;
    const canonicalPath = url || pageUrl;
    const ogImage = image || SITE_OG_IMAGE;
    const locale = language === 'sw' ? 'sw_TZ' : 'en_US';
    const alternateLocale = language === 'sw' ? 'en_US' : 'sw_TZ';

    upsertCanonical(canonicalPath);
    upsertHreflang('en', pageUrl);
    upsertHreflang('sw', pageUrl);
    upsertHreflang('x-default', pageUrl);

    upsertMeta('description', description);
    upsertMeta('keywords', keywords);
    upsertMeta('robots', noindex ? 'noindex, nofollow' : 'index, follow');

    upsertMeta('og:title', title || document.title, true);
    upsertMeta('og:description', description, true);
    upsertMeta('og:type', type, true);
    upsertMeta('og:url', canonicalPath, true);
    upsertMeta('og:image', ogImage, true);
    upsertMeta('og:locale', locale, true);
    upsertMeta('og:locale:alternate', alternateLocale, true);

    upsertMeta('twitter:card', 'summary_large_image', true);
    upsertMeta('twitter:title', title || document.title, true);
    upsertMeta('twitter:description', description, true);
    upsertMeta('twitter:image', ogImage, true);
  }, [title, description, keywords, image, url, type, noindex, location.pathname, language]);

  return null;
};

export default SEO;
